<template>
    <div class="NotesCard">
        <div class="NotesCard__header-bar">
            <div
                class="NotesCard__header"
                @click="$emit('close')"
            >
                <StreamlineIcon
                    v-if="feedMode"
                    class="NotesCard__close-icon"
                    :icon="NavigationMenu2"
                    stroke="white"
                    :fill="textGrey"
                    :size="16"
                />
                Notes ({{ notes.length }})
            </div>
            <div
                v-if="feedMode && notes.length > 3"
                class="NotesCard__see-more"
                @click="$emit('nav-to-review')"
            >
                See more notes
                <StreamlineIcon
                    class="NotesCard__see-more-icon"
                    :icon="ArrowRight"
                    :fill="textLink"
                    :size="12"
                />
            </div>
        </div>
        <div class="NotesCard__notes-container">
            <Note
                v-for="(note, index) in filteredNotes"
                :key="JSON.stringify(note)"
                :note="note"
                :background-color="index % 2 === 1 ? 'white' : 'grey'"
            />
        </div>
        <AddNote
            :show-add-note="showAddNote"
            :status="internalStatus"
            :response-id="responseId"
            :review-id="reviewId"
            @toggle-note="setAddNote"
            @create="createNote"
        />
    </div>
</template>
<script>
import Note from './NotesCard/Note.vue';
import AddNote from './NotesCard/AddNote.vue';
import cloneDeep from 'lodash/cloneDeep';
import stat from 'status/index';
import StreamlineIcon from "@reviewpush/streamline-icons-vue";
import {NavigationMenu2} from "@reviewpush/streamline-regular/lib/interface-essential/Menu";
import {ArrowRight} from "@reviewpush/streamline-bold/lib/arrows-diagrams/Arrows";
import {
    textGrey,
    textLink
} from 'style/_colors.scss';
import getStatus from '@/helpers/getStatus';
import moment from 'moment';

export default {
    name: 'RPNotesCard',
    components: {
        StreamlineIcon,
        Note,
        AddNote
    },
    props: {
        notes: {
            type: Array,
            required: true
        },
        reviewId: {
            type: [String, Number],
            required: true,
        },
        responseId: {
            type: [String, Number],
            required: true,
        },
        feedMode: {
            type: Boolean,
            default: true
        },
        status: {
            type: [String, Array],
            default: stat.STANDBY,
        },
    },
    data(){
        return {
            showAddNote: true,
            statusId: -1,

            NavigationMenu2,
            ArrowRight,
            textGrey,
            textLink,
        };
    },
    computed: {
        internalStatus(){
            return Array.isArray(this.status)
                ? getStatus(this.status, this.statusId)
                : this.status;
        },
        filteredNotes(){
            const n = this.feedMode
                ? cloneDeep(this.notes).splice(0, 3)
                : this.notes;
            return n.reverse();
        }
    },
    watch: {
        notes(newNotes, oldNotes){
            this.showAddNote = !(newNotes.length > oldNotes.length);
        }
    },
    mounted(){
        document.addEventListener('click', this.closeNotes);
    },
    destroyed(){
        document.removeEventListener('click', this.closeNotes);
    },
    methods: {
        createNote(args){
            this.statusId = moment().format();
            this.$emit('create', {
                requestId: this.statusId,
                reviewId: this.reviewId,
                ...args
            });
        },
        closeNotes(e) {
            if(!this.$el.contains(e.target) && !this.feedMode){
                this.$emit('close');
            }
        },
        setAddNote(bool){
            this.showAddNote = bool;
        },
    }
};
</script>
<style lang="scss">
.NotesCard {
    height: fit-content;
    border-radius: 4px;
    background: $white;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.08);

    &__header-bar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1rem;
    }
    &__header {
        display: flex;
        align-items: center;
        cursor: pointer;
        font-weight: 600;
    }
    &__close-icon {
        margin-right: 0.5rem;
    }
    &__see-more{
        display: flex;
        align-items: center;
        color: $text-link;
        cursor: pointer;
        font-size: 0.85rem;
    }
    &__see-more-icon {
        margin-left: 0.25rem;
    }
}
</style>

<docs>
```vue
<RPNotesCard
    :reviewId="1"
    :responseId="1"
    :notes="[
        {
            'type': 'note',
            'note': 'Non ratione nihil et in eos odit. Qui veritatis tempore rerum. Est sunt vitae cum consequatur rerum. Laboriosam ullam voluptatem ratione dolorum fuga et ex.',
            'user': 'Response Creator',
            'user_id': 4,
            'date': '2020-10-24T22:14:50-05:00'
        },
        {
            'type': 'activity',
            'activity': 'Submitted',
            'note': '',
            'response': 'Rerum dolor nulla modi illo possimus velit nostrum. In sed deserunt ea nostrum rerum voluptatem. Architecto voluptatibus pariatur debitis. Sint rerum sed corrupti ea.',
            'status_before': 'Unpublished',
            'status_after': 'Pending',
            'user': 'Response Creator Approver',
            'user_id': 6,
            'date': '2020-10-12T22:14:49-05:00',
            'user_image': null
        }
    ]">
</RPNotesCard>
<br>
<RPNotesCard
    :reviewId="1"
    :responseId="1"
    :notes="[
        {
            'type': 'note',
            'note': 'Non ratione nihil et in eos odit. Qui veritatis tempore rerum. Est sunt vitae cum consequatur rerum. Laboriosam ullam voluptatem ratione dolorum fuga et ex.',
            'user': 'Response Creator',
            'user_id': 4,
            'date': '2020-10-24T22:14:50-05:00'
        },
        {
            'type': 'activity',
            'activity': 'Submitted',
            'note': '',
            'response': 'Rerum dolor nulla modi illo possimus velit nostrum. In sed deserunt ea nostrum rerum voluptatem. Architecto voluptatibus pariatur debitis. Sint rerum sed corrupti ea.',
            'status_before': 'Unpublished',
            'status_after': 'Pending',
            'user': 'Response Creator Approver',
            'user_id': 6,
            'date': '2020-10-12T22:14:49-05:00',
            'user_image': null
        },
        {
            'type': 'activity',
            'activity': 'Submitted',
            'note': '',
            'response': 'Rerum dolor nulla modi illo possimus velit nostrum. In sed deserunt ea nostrum rerum voluptatem. Architecto voluptatibus pariatur debitis. Sint rerum sed corrupti ea.',
            'status_before': 'Unpublished',
            'status_after': 'Pending',
            'user': 'Response Creator Approver',
            'user_id': 6,
            'date': '2020-10-12T22:14:49-05:34',
            'user_image': null
        },
        {
            'type': 'activity',
            'activity': 'Submitted',
            'note': '',
            'response': 'Rerum dolor nulla modi illo possimus velit nostrum. In sed deserunt ea nostrum rerum voluptatem. Architecto voluptatibus pariatur debitis. Sint rerum sed corrupti ea.',
            'status_before': 'Unpublished',
            'status_after': 'Pending',
            'user': 'Response Creator Approver',
            'user_id': 6,
            'date': '2020-10-12T22:14:49-05:55',
            'user_image': null
        }
    ]"
    feed-mode>
</RPNotesCard>
```
</docs>
